import React from "react";
import { Box } from "@mui/material";
import { getLocalisationVal } from "@/utils/localizationUtil";
import useStyles from "./styles";
import PriceTrend from "@/components/priceTrend";

const Price = (props) => {
  const { localization, code, price, trend, mr = 8 } = props;
  const classes = useStyles();

  return (
    <Box display={"flex"} alignItems={"flex-end"} mr={mr}>
      <span className={classes.codeText}>{code}</span>
      <span className={classes.priceText}>
        {getLocalisationVal(localization, price)}
      </span>
      <Box minWidth={50}>
        <PriceTrend fontSize={14} trend={trend} />
      </Box>
    </Box>
  );
};

export default Price;
